import React, { useState } from 'react';
import axios from 'axios';

export default function EnquiryForm() {
  const [form, setForm] = useState({
    to_phone: '',
    seller_name: '',
    buyer_name: '',
    product: '',
    buyer_message: '',
    buyer_email: '',
    buyer_phone: '',
    quantity: '',
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/calls/enquiry`, form);
      const callId = res.data?.result?.call_id || 'started';
      setStatus(`Call started! ID: ${callId}`);
      setForm({ to_phone: '', seller_name: '', buyer_name: '', product: '', buyer_message: '', buyer_email: '', buyer_phone: '', quantity: '' });
    } catch (err) {
      const msg = err.response?.data?.detail?.error || err.response?.data?.detail || err.message;
      setStatus(msg || 'Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-card">
      <div className="form-header">Enter the enquiry details. The agent will brief the seller clearly and concisely.</div>
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <div className="field">
            <label className="label">Seller Phone *</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.31 1.77.57 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.09a2 2 0 0 1 2.11-.45c.84.26 1.71.45 2.61.57A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <input name="to_phone" type="tel" placeholder="+91 00000 00000" value={form.to_phone} onChange={handleChange} required />
            </div>
          </div>
          <div className="field">
            <label className="label">Seller Name *</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <input name="seller_name" type="text" placeholder="e.g., Rahul Traders" value={form.seller_name} onChange={handleChange} required />
            </div>
          </div>
        </div>

        <div className="form-grid">
          <div className="field">
            <label className="label">Buyer Name *</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <input name="buyer_name" type="text" placeholder="e.g., Aisha Khan" value={form.buyer_name} onChange={handleChange} required />
            </div>
          </div>
          <div className="field">
            <label className="label">Product *</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 7l9-4 9 4-9 4-9-4z" stroke="currentColor" strokeWidth="2"/><path d="M3 7v10l9 4 9-4V7" stroke="currentColor" strokeWidth="2"/><path d="M12 11v10" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <input name="product" type="text" placeholder="e.g., Apples Grade A" value={form.product} onChange={handleChange} required />
            </div>
          </div>
        </div>

        <div className="form-grid">
          <div className="field field-span-2">
            <label className="label">Buyer Message *</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v14H7l-3 3V4z" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <textarea name="buyer_message" placeholder="Key details the buyer shared" value={form.buyer_message} onChange={handleChange} required />
            </div>
          </div>
        </div>

        <div className="form-grid">
          <div className="field">
            <label className="label">Quantity (optional)</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <input name="quantity" type="text" placeholder="e.g., 200 kg" value={form.quantity} onChange={handleChange} />
            </div>
          </div>
          <div className="field">
            <label className="label">Buyer Email (optional)</label>
            <div className="input-group">
              <span className="icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M4 6h16v12H4z" stroke="currentColor" strokeWidth="2"/><path d="M4 6l8 7 8-7" stroke="currentColor" strokeWidth="2"/></svg>
              </span>
              <input name="buyer_email" type="email" placeholder="buyer@example.com" value={form.buyer_email} onChange={handleChange} />
            </div>
          </div>
        </div>

        <div className="field">
          <label className="label">Buyer Phone (optional)</label>
          <div className="input-group">
            <span className="icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.86 19.86 0 0 1 2.08 4.18 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.12.9.31 1.77.57 2.61a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.47-1.09a2 2 0 0 1 2.11-.45c.84.26 1.71.45 2.61.57A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2"/></svg>
            </span>
            <input name="buyer_phone" type="tel" placeholder="+91 00000 00000" value={form.buyer_phone} onChange={handleChange} />
          </div>
        </div>

        <div className="button-row">
          <button type="submit" disabled={loading}>{loading ? 'Calling…' : 'Submit Request'}</button>
        </div>
      </form>
      {status && <p className={`status ${status.toLowerCase().includes('call') ? 'success' : 'error'}`}>{status}</p>}
    </div>
  );
}
